import { ref, watch } from 'vue';
import { DefaultLang } from '@/constants/constants';
import PageResources, { loadPageResources } from '../model/index';

export default function usePageResources(locale, lang = DefaultLang) {
  const pageResources = ref(PageResources[lang]);
  const updatePageResource = async (newLocale) => {
    const resources = await loadPageResources(newLocale || lang);
    if (newLocale === locale.value) {
      pageResources.value = resources[locale.value || lang];
    }
  };

  updatePageResource(locale.value || lang);
  watch(locale, updatePageResource);

  return {
    pageResources,
  };
}
